/**
 * TimelineSpanRow — `timeline[row].span` / `timeline[column].span`
 * renderer. Paints a labeled span-bar across a range, driven by
 * `(obj, scalar|multi, Slot|Event)` source cells.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/**
 * The timeline span renderer row: paints a labelled bar across a range from its source row's slot
 * or event cells.
 */
export class TimelineSpanRow extends RendererRow {
  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }

  get label(): Option<string> {
    return Json.string(this.attrs(), "label");
  }
}
